export const DEFAULT_MAX_NESTED = 10;
export const DEFAULT_MAX_DEPTH = 3;
export const AUTO_COLLAPSE_THRESHOLD = 4;
